import React, { Component, Fragment } from 'react';

// Bootstrap component
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button'

import { processResponse, stringFormat, redirectionUrl } from '../../../utilities/processResponse';

import ThankYouPageSection from '../Section/ThankYouPageSection';
// Assets
import './ThankYouPage.css';

class ThankYouPage extends Component {

    componentDidMount() {
        try {
            const { thankYouPageContinueButtonKey, redirections, buttons, properties } = this.props.pageInstrumentConfiguration;
            const { SubmitAsFinalRedirectionUrl } = redirections;

            if (SubmitAsFinalRedirectionUrl !== "" && redirections && Object.keys(redirections).length !== 0 && thankYouPageContinueButtonKey === null && properties.daisyChainOption === "1") {
                this.handleAutoRedirection();

            } else if (SubmitAsFinalRedirectionUrl !== "" && redirections && Object.keys(redirections).length !== 0 && thankYouPageContinueButtonKey !== null && buttons.hasOwnProperty(thankYouPageContinueButtonKey) !== undefined && buttons[thankYouPageContinueButtonKey].buttonText === "" && buttons[thankYouPageContinueButtonKey].buttonOption === 0 && properties.daisyChainOption === "1") {
                this.handleAutoRedirection();
            }
        } catch (error) {
            console.log("Exceptions:component did mount" + error.message);
        }
    }

    componentDidUpdate() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    handleAutoRedirection = () => {
        try {
            const { properties, sections, thankYouPage  } = this.props.pageInstrumentConfiguration;
            var thankYouPageAutoRedirectTimer = properties && properties.thankYouPageAutoRedirectTimer !== "" ? properties.thankYouPageAutoRedirectTimer : 2000;

            const { introSectionKey } = thankYouPage;
            const content = sections.hasOwnProperty(introSectionKey) ? sections[introSectionKey].content: null;
            const redirectTimer = content !== null && content !== "" ? thankYouPageAutoRedirectTimer !== 0 ? thankYouPageAutoRedirectTimer: null : 0;

            if (redirectTimer !== null && content !== null && content !== "") {
                var resetTimer = setTimeout(() => {
                    this.handleRedirection();
                    clearTimeout(resetTimer);
                }, redirectTimer);
            } else {
                console.log('no redirection');
            }

        } catch (error) {
            console.log("Exceptions:while redirecting url in thank you page_:", error.message)
        }
    }

    handleRedirection = () => {
        try {
            const { redirections, substitutions } = this.props.pageInstrumentConfiguration;
            const { SubmitAsFinalRedirectionUrl } = redirections;

            var redirectUrl = `${SubmitAsFinalRedirectionUrl}`;
            var urlRedirect = redirectionUrl(redirectUrl, substitutions);

            if (urlRedirect && urlRedirect !== "undefined" && navigator.onLine) {
                window.location.href = urlRedirect;
            }
        } catch (error) {
            console.log("Exceptions:While redirecting to the url:_", error.message);
        }
    }

    render() {
        const { pageInstrumentConfiguration } = this.props;
        const { sections, thankYouPage, pageCssClass, substitutions, buttons, thankYouPageContinueButtonKey, redirections } = pageInstrumentConfiguration;
        const {
            pagePreSectionKey,
            pagePostSectionKey,
            introSectionKey
        } = thankYouPage;

        const content = sections.hasOwnProperty(introSectionKey) ? processResponse(sections[introSectionKey].content): null;

        return (
            <Fragment>
                { pagePreSectionKey !== null && sections.hasOwnProperty(pagePreSectionKey) ?
                    <ThankYouPageSection
                        type="pre"
                        key={sections[pagePreSectionKey].key}
                        html={sections[pagePreSectionKey].content}
                        className={sections[pagePreSectionKey].className}
                    />:null}
                <Container className={pageCssClass}>
                    { introSectionKey !== null && sections.hasOwnProperty(introSectionKey) ?
                    <Row>
                        <Col md="2"></Col>
                        <Col md="8" className={`_ThankYouPageIntroSection ${sections[introSectionKey].className}`}>
                            <div dangerouslySetInnerHTML={{__html:stringFormat(content, null, null, null, null, substitutions)}}></div>
                        </Col>
                        <Col md="2"></Col>
                    </Row>:null}
                    <Row>
                        <Col md="2"></Col>
                        <Col md="8" className="text-center">
                        {thankYouPageContinueButtonKey !== null && buttons.hasOwnProperty(thankYouPageContinueButtonKey) && buttons[thankYouPageContinueButtonKey].buttonOption !== 0 ?
                            <Button
                                key={buttons[thankYouPageContinueButtonKey].key}
                                className={`_ThankYouPageContinueButton ${buttons[thankYouPageContinueButtonKey].buttonCssClass}`}
                                variant="primary"
                                size="lg"
                                onClick={() => this.handleRedirection()}
                            >
                                {thankYouPageContinueButtonKey !== null ? buttons[thankYouPageContinueButtonKey].buttonText : null}
                            </Button>:null}
                        </Col>
                        <Col md="2"></Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            { pagePostSectionKey !== null && sections.hasOwnProperty(pagePostSectionKey) ?
                                <ThankYouPageSection
                                type="post"
                                key={sections[pagePostSectionKey].key}
                                html={sections[pagePostSectionKey].content}
                                className={sections[pagePostSectionKey].className}
                                />: null}
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

export default ThankYouPage;
